<template>
    <div class="flex w-full h-full history-view justify-content-around">
        <LibyanOrnament vertical class="lib-or mr-5"/>
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.historyList.header') }}</h2>
                <CustomButton :label="$t('message.historyList.export')"
                              @click="exportCSV" v-if="isAdmin"/>
            </div>
            <HistoryTable ref="historyTable"/>
        </div>
    </div>
</template>

<script>
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import HistoryTable from "@/views/history/components/HistoryTable.vue";
import {SystemRole} from "@/utils/SystemRole";

export default {
    name: "HistoryListView",
    components: {
        HistoryTable,
        CustomButton,
        LibyanOrnament,
    },

    data() {
        return {
            systemRole: SystemRole.getUserRole(),
        };
    },

    computed: {
        isAdmin() {
            return this.systemRole === SystemRole.ADMIN;
        },
    },

    methods: {
        reloadTable() {
            this.$refs.historyTable.reloadTable();
        },
        exportCSV() {
            this.$refs.historyTable.exportCSV();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/theme/mytheme/variables";
.history-view {
    @media screen and (max-width: 750px) {
        .lib-or {
            display: none;
        }
    }
    @media screen and (max-width: 650px) {
        padding: 0 20px;
    }
}
</style>
